const queryString = require('query-string');

$(function () {
    let App = window.App;
    App.modal = {};

    let $documentBody = $(document.body);
    let openModals = [];

    App.modal.closeOpenModal = function ($modal = undefined) {
        if (openModals.length > 0) {
            if ($modal) {
                let index = openModals.findIndex($openModal => $openModal[0] === $modal[0]);

                if (index != -1) {
                    $modal.find('.modal-close').trigger('click');

                    openModals = openModals.splice(index);
                }
            } else {
                openModals.pop().find('.modal-close').trigger('click');
            }
        }

        if (openModals.length == 0) {
            $documentBody.removeClass('open-modal');
        }
    }

    App.modal.submitForm = function (token = null) {
        let $modal = $('.modal.open')
        let $form = $modal.find('form');

        $form.find('.alert.alert-error').remove();

        if ($form.valid()) {
            let $submitBtn = $modal.find('[type="submit"]');
            let data = queryString.parse($form.serialize());

            if (token) {
                data.captcha_token = token;
            }

            $.ajax({
                type: $form.attr('method'),
                url: $form.attr('action'),
                data: queryString.stringify(data),
                dataType: 'json',
                beforeSend: function () {
                    $submitBtn.addClass('is-loading').attr('disabled', 'disabled');
                },
                success: function (response) {
                    if (response.status === "OK") {
                        App.modal.closeOpenModal();
                        App.menu.closeOpenMenu();

                        if (response.hasOwnProperty('modal_view')) {
                            let timer = setTimeout(function () {
                                $('footer').before(response.modal_view);
                                $('body').addClass('open-modal');
                                clearTimeout(timer);
                            }, 200);
                        }
                    }

                    if (response.status === 'ERROR') {
                        if (response.message) {
                            App.modal.showErrors($form, response.message);
                        }

                        if (response.errors) {
                            for (let key in response.errors) {
                                App.modal.showErrors($form, response.errors[key]);
                            }
                        }
                    }
                },
                complete: function () {
                    $submitBtn.removeClass('is-loading').removeAttr('disabled');
                }
            });
        }
    }

    App.modal.open = function ($modal) {
        if ($modal.length && !$modal.hasClass('open')) {
            let $form = $modal.find('form');

            if ($form.length) {
                $form.validate();
            }

            if (!(openModals.length > 0 && openModals[openModals.length - 1].attr('data-allow-open-on-top'))) {
                App.modal.closeOpenModal();
            }

            App.menu.closeOpenMenu();

            let timer = setTimeout(function () {
                openModals.push($modal);
                $modal.addClass('open');
                $documentBody.addClass('open-modal');
                clearTimeout(timer);
            }, 200);
        }
    }

    $(document).on('click', '[data-modal]', function () {
        let needModal = $(this).data('modal');
        let $modal = $(needModal);

        if ($modal.length) {
            App.modal.open($modal);
        } else {
            console.error(`Modal "${needModal}" not found.`)
        }
    });

    $(document).on('click', '.modal-dialog', function (e) {
        if (e.target !== this) {
            return;
        }

        App.modal.closeOpenModal();
    });

    $(document).on('click', '.modal [data-modal-close]', function () {
        let $modal = $(this).closest('.modal');

        $modal.removeClass('open');
        $documentBody.removeClass('open-modal');

        let $form = $modal.find('form');
        App.modal.resetForm($form);

        if ($modal.attr('data-received') !== undefined) {
            let timer = setTimeout(function () {
                $modal.remove();
                clearTimeout(timer);
            }, 500);
        }
    });

    App.modal.resetForm = function ($form) {
        if ($form.length) {
            $form.validate().resetForm();
            $form.trigger('reset');
            $form.find('.error').removeClass('error');
            $form.find('.valid').removeClass('valid');
        }
    }

    App.modal.showErrors = function ($form, message) {
        $form.append(`<div class="alert alert-error">${message}</div>`)
    }
});